module.exports = __webpack_public_path__ + "img/plant_6_mobile_small.882d8f08.webp";